import React from 'react';

const MilestoneNotification = ({ notification, onClose }) => {
  if (!notification) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: notification.milestone.color,
        color: 'white',
        padding: '20px 40px',
        borderRadius: '12px',
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
        zIndex: 3000,
        textAlign: 'center',
        animation: 'slideDown 0.5s ease',
        minWidth: '300px'
      }}
      onClick={onClose}
    >
      <div style={{ fontSize: '3rem', marginBottom: '10px' }}>
        {notification.milestone.emoji}
      </div>
      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '5px' }}>
        {notification.milestone.label}-Medaille!
      </div>
      <div style={{ fontSize: '1.1rem' }}>
        Glückwunsch {notification.name}, du hast {notification.milestone.km}km erreicht!
      </div>
      <div style={{ fontSize: '0.9rem', marginTop: '5px', opacity: 0.9 }}>
        Gesamt: {notification.total.toFixed(1)}km
      </div>
    </div>
  );
};

export default MilestoneNotification;
